<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import measuringWindow from './images/arched-window-install-resized-2.png';
	import oddShaped from './images/IMG_7622-1024x768-1.jpg';
	import shapes from './images/Shapes-names-1-1200x252.png';
	import archedWindowBedroom from './images/shutterstock_1198475926.png';
	import triangleWindow from './images/shutterstock_1733670947.png';
	import topTriangleWindow from './images/shutterstock_1995203636.png';
	import archedKitchen from './images/shutterstock_2011142156.png';
	import circleWindow from './images/shutterstock_467147480.png';
</script>

<Section>
	<h2>Oddly Shaped & Specialty Windows Require A Specialty Solution</h2>
	<p>
		Window inserts are an easy, affordable way to make your home more
		comfortable and energy efficient without blocking light, but many homeowners
		find themselves unable to enjoy the benefits of inserts if their specialty
		windows aren’t perfectly rectangular.
	</p>
	<p>
		Round or circle windows, arched windows, triangle windows that fit the gable
		of your home, trapezoid windows, bowed windows, and other odd shaped windows
		can be difficult to insulate from cold drafts, loud noises, and other
		unwelcome intrusions, but luckily, Indow has the perfect solution for even
		the most peculiar of window shapes and sizes.
	</p>
	<Image src={archedKitchen} alt="arch window in brightly lit kitchen" />
</Section>
<Section>
	<h2>Custom Windows Require A Custom Window Insert</h2>
	<p>
		With our innovative technology, Indow manufactures customized inserts to fit
		any specialty shape window. Our high-quality specialty acrylic and snug-fit
		compression tubing means our inserts can make your home warmer in the
		winter, cooler in the summer, and quieter all year – all while helping you
		lower your energy bills.
	</p>
	<p>
		To get started, we’ll provide you with detailed instructions on how to
		create a template of your specialty window, using Tyvek or a similar
		material. You’ll trace the shape of your window, measure the dimensions
		using our Laser Measure Kit and submit both your template and measurement
		for production.
	</p>
	<p>
		Once we receive your template, our production team will get started crafting
		a window insert that will perfectly fit the space of your specialty window.
		With our compression tubing, your new speciality shape inserts will slide
		snugly into place. You’ll barely even see them – but you’ll certainly be
		able to tell the difference in the comfort and quiet of your home!
	</p>
	<Image src={measuringWindow} alt="arch window in brightly lit kitchen" />
</Section>
<Section>
	<h2>An Indow Insert For Every Shape Of Window</h2>
	<p>
		If you’re not sure about the shape of your window or how to insulate it –
		don’t fret – just get in touch with one of our Window Experts and we’ll
		guide you through every step.
	</p>
	<p>
		We are able to custom-cut inserts for nearly every kind of specialty window
		shape – but here are some examples of the most common window shapes and
		styles that we work with.
	</p>
	<Image src={shapes} alt="specialty shapes and names in a line" />
</Section>
<Section>
	<h2>Round, Half Round, Quarter Round, Circle, or Half Circle Window</h2>
	<Image src={circleWindow} alt="Round circle window overlooking bathroom" />

	<p>
		These shapes, often interchangeably called round and circle windows, are
		distinctive and beautiful architectural additions to your home.
	</p>
	<p>
		However, it is easy to confuse round or circle windows with arch windows, so
		here is how we differentiate:
	</p>
	<ul>
		<li>
			<p class="text-left">
				A full round shape is a circular shape with consistent diameter from any
				point.
			</p>
		</li>
		<li>
			<p class="text-left">
				A half round shape has a straight, bottom base with a consistent radius
				top.
			</p>
		</li>
	</ul>
</Section>
<Section>
	<h2>Arch Window & Extended Segments</h2>
	<Image src={archedWindowBedroom} alt="arched window above bed" />

	<p>
		Arched windows differ from round or circle windows in that the window has a
		rectangular base but a consistent radius arc on top that merges with the
		rectangle portion of the window by cleanly rolling into parallel sides.
	</p>
	<p>
		Indow also custom crafts many inserts for extended segments, which are
		similar to arch windows. An extended segment differs in that the arc on top
		is a partial, inconsistent radius on top that merges with the rectangle
		portion of the window.
	</p>
</Section>
<Section>
	<h2>Triangle Window</h2>
	<Image
		src={topTriangleWindow}
		alt="triangle window looking out at beautiful blue sky"
	/>

	<p>
		Triangle windows are a popular design choice because they allow for the
		natural beauty outside to be accentuated by the angles of the window,
		increasing the bond between homeowner and the place they live in.
		Furthermore, triangle windows can be used to match the angles of the roof,
		creating an eye-catching architectural element.
	</p>
</Section>
<Section>
	<h2>Trapezoid Window</h2>
	<Image
		src={triangleWindow}
		alt="mother and child sitting near trapezoid window"
	/>
	<p>
		The definition of trapezoid windows encompasses a lot of common shapes, but
		at Indow we use a wide and gracious definition: A trapezoid is a flat shape
		with 4 straight sides that has a pair of opposite sides parallel and often
		with 2 squared corners.
	</p>
	<p>
		This means that gable windows, raked windows, and some windows that include
		triangle shapes at the top of the rectangular shape are all referred to as
		trapezoid windows.
	</p>
	<p>
		An angular gable window uses angled sides that run parallel to the gable
		roof of a house. A raked window, similarly, uses irregular angles and sides
		to mimic and run parallel to the roof lines – but can be applied to roofs
		other than just gable roofs.
	</p>
</Section>
<Section>
	<h2>Your Source For Specialty Window Inserts</h2>
	<Image src={oddShaped} alt="an Indow insert for an odd shaped window" />

	<p>
		Specialty windows come in a wide variety of shapes, sizes, and styles – but
		regardless of the specifics, Indow will be alongside you in every step of
		the process to measure, insert, and enjoy your specialty window inserts.
	</p>
	<p>
		Learn more about how you can begin the process of enjoying your specialty
		windows more by <a href="/how-to/get-indow-inserts"
			>talking to one of our Window Experts today</a
		>.
	</p>
</Section>
